import { BLANK_REGEX } from './regex';

export const alphabeticCompare = (aString, otherString) => aString.localeCompare(otherString) === 0;

export const capitalizeFirstLetter = string =>
  string?.[0].toUpperCase().concat(string.slice(1).toLowerCase());

export const validateStringWithRegex = (string, regex) => !string || !!string.match(regex);

export const getLastChar = str => str[str.length - 1];

export const simplifyChars = str =>
  str
    ?.toLowerCase()
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '');

export const hasSearch = (str, search, format) =>
  simplifyChars(format ? format(str) : str)?.includes(simplifyChars(search));

export const parseBool = value => (value === 'false' ? false : value === 'true' ? true : value);

export const takeNCharacters = amount => str => str.slice(0, amount);

export const dropNCharacters = amount => str => str.slice(amount, str.length);

export const isBlank = str => BLANK_REGEX.test(str);
